module.exports = __webpack_public_path__ + "static/fondovector-a953d1bde3c9c224fade30dd3eac93e5.svg";